import { io } from "socket.io-client";

// One live connection per tab, shared by everything that listens to server
// events (alert popups, approvals). Each user acquires it on mount and
// releases it on unmount; the last release disconnects.
const SOCKET_PATH = "/api/socket.io";

let socket = null;
let holders = 0;

export const acquireSocket = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_BASE_URL || undefined, {
      path: SOCKET_PATH,
      auth: { token: localStorage.getItem("authorization") },
    });
  }
  holders += 1;
  return socket;
};

export const releaseSocket = () => {
  holders = Math.max(holders - 1, 0);
  if (holders === 0 && socket) {
    socket.disconnect();
    socket = null;
  }
};
